import React from 'react';

const styles = {
    fileinput: {
        width: '0.1px',
        height: '0.1px',
        opacity: 0,
        overflow: 'hidden',
        position: 'absolute',
        zIndex: -1
    },
    filelabel: {
        fontSize: '1em',
        fontWeight: 700,
        color: 'white',
        display: 'inline-block',
        padding: '.4em',
        margin: '0 0 .5em 0',
        cursor: 'pointer',
    },
}

const DonationForm = (props) => {
    
    const { accepted, inReport, largeAmount, file } = props.donations;

    return (
        <div>
            <div style={{marginTop: '1em', minWidth: '50vw'}}>
                <div><strong>Donationer</strong></div>
                <p>Har trossamfundet/menigheden modtaget donationer?</p>
                <div><label><input type="radio" name="donationsAccepted" value="option1" onChange={props.onChange} checked={accepted === "option1"} /> Ja</label></div>
                <div><label><input type="radio" name="donationsAccepted" value="option2" onChange={props.onChange} checked={accepted === "option2"} /> Nej</label></div>
            </div>
            {
                accepted === "option1" && <div style={{margin: '1.5em 0'}}>
                <div>
                    <p>Hvis ja, har menigheden/trossamfundet modtaget en eller flere donationer fra samme donator, der enkeltvis eller samlet overstiger 20.000 kr.?</p>
                    <div><label><input type="radio" name="donationsLargeAmount" value="option1" onChange={props.onChange} checked={largeAmount === "option1"} /> Ja</label></div>
                    <div><label><input type="radio" name="donationsLargeAmount" value="option2" onChange={props.onChange} checked={largeAmount === "option2"} /> Nej</label></div>
                </div>
            </div>
            }
            {
                accepted === "option1" &&
                    <div style={{margin: '1.5em 0'}}>
                        <div>
                            <p>Hvis ja. Fremgår donationerne af det uploadede årsregnskab?</p>
                            <div><label><input type="radio" name="donationsInReport" value="option1" onChange={props.onChange} checked={inReport === "option1"} /> Ja</label></div>
                            <div><label><input type="radio" name="donationsInReport" value="option2" onChange={props.onChange} checked={inReport === "option2"} /> Nej</label></div>
                        </div>
                    </div>
            }
            {props.user.type==="user" && inReport === "option1" && accepted === "option1" &&
                <div style={{marginTop: '1em'}}>
                <label style={{fontSize: '1em', padding: 0, margin: 0}}>
                <input type="checkbox" name="gdpr" onChange={props.onChange} checked={props.gdpr} />
                Jeg erklærer hermed på tro og love, at oversigten over donationer, der enkeltvis eller samlet overstiger 20.000 kr., ikke indeholder oplysninger om enkeltpersoner eller enkeltmandsfirmaer, jf. § 17, stk. 3, 2. pkt., i bekendtgørelse nr. 1283 af 15. november 2018.
                </label>
            </div>
            }
            {inReport==="option2" &&
                accepted==="option1" &&
                <div style={{margin: '1.5em 0'}}>
                    <p>Hvis nej:</p>
                    <input 
                        style={styles.fileinput} 
                        id={props.year + "_donationsFile"} 
                        type="file" 
                        name="donationsFile" 
                        onChange={props.onChange} 
                        ref={props.inputRef} />
                    <label className="upload" htmlFor={props.year + "_donationsFile"} style={styles.filelabel}>{file ? file.name : 'Upload bilag vedr. donationer'}</label>
                <div className="form-helper-label">Kun PDF-filer på max 20 MB tilladt.</div>
            </div>}
            {props.user.type==="user" && inReport==="option2" && accepted==="option1" &&
                <div style={{marginTop: '1em'}}>
                <label style={{fontSize: '1em', padding: 0, margin: 0}}>
                <input type="checkbox" name="gdpr" onChange={props.onChange} checked={props.gdpr} />
                Jeg erklærer hermed på tro og love, at oversigten over donationer, der enkeltvis eller samlet overstiger 20.000 kr., ikke indeholder oplysninger om enkeltpersoner eller enkeltmandsfirmaer, jf. § 17, stk. 3, 2. pkt., i bekendtgørelse nr. 1283 af 15. november 2018.
                </label>
            </div>
            }
        </div>
    )
}

export default DonationForm;


// WEBPACK FOOTER //
// ./src/modules/reports/DonationsForm.js